import api from './api';

/**
 * Invoice Service
 * Handles all invoice-related API calls
 */
const invoiceService = {
    /**
     * Get all invoices
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/invoices${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get invoice by ID
     * @param {string} id - Invoice ID
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/user/invoices/${id}`);
    },

    /**
     * Create new invoice
     * @param {Object} data - Invoice data
     * @returns {Promise<Object>}
     */
    create: async (data) => {
        return api.post('/user/invoices', data);
    },

    /**
     * Update invoice
     * @param {string} id - Invoice ID
     * @param {Object} data - Updated invoice data
     * @returns {Promise<Object>}
     */
    update: async (id, data) => {
        return api.put(`/user/invoices/${id}`, data);
    },

    /**
     * Delete invoice
     * @param {string} id - Invoice ID
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/user/invoices/${id}`);
    },

    /**
     * Get invoice summary/statistics
     * @returns {Promise<Object>}
     */
    getSummary: async () => {
        return api.get('/user/invoices/summary');
    }
};

export default invoiceService;
